type Tag = {
  tag: string;
  description: string;
};

export const tagRegex = (tag: string) => new RegExp(`<${tag}>(.+?)</${tag}>`);

export const TAGS_METADATA = [
  {
    tag: 'b',
    description: 'Bolds the enclosed text.',
  },
  {
    tag: 'u',
    description: 'Underlines the enclosed text.',
  },
  {
    tag: 'i',
    description: 'Italicizes the enclosed text.',
  },
  {
    tag: 'sup',
    description: 'Superscripts the enclosed text.',
  },
  {
    tag: 'lci',
    description: 'Bolds the enclosed text and changes the color to green.',
  },
  {
    tag: 'vr',
    description: 'Bolds the enclosed text and changes the color to blue.',
  },
] as const satisfies readonly Pick<Tag, 'tag' | 'description'>[];
